import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { iron, orangered } from 'styles/abstract/variables';

export const makePaperClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            borderLeft: `${theme.spacing(0.5)}px solid ${orangered}`,
        },
    }),
    { index: 1 },
);

export const makePriceClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            color: orangered,
            fontSize: '1.25rem',
            fontWeight: 600,
        },
    }),
    { index: 1 },
);

export const makeSummaryTitleClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            borderBottom: `${theme.spacing(0.125)}px solid ${iron}`,
            marginBottom: theme.spacing(2),
        },
    }),
    { index: 1 },
);
